import Card from '../Card'
import { styled } from '../../utils/styled'
import Grid from '../Grid'
import { type ToasterVariant } from './types'
import { LinearProgress } from '@mui/material'

export const StyledCardToaster = styled(Card)(({ theme }) => ({
  boxShadow: theme.elevation.mediumDepth,
  position: 'fixed',
  bottom: '32px',
  right: '32px',
  zIndex: 1500,
  padding: '19px 20px',
  width: '352px',
  margin: 0,
  backgroundColor: theme.tokens.background.main.default
}))

export const StyledGridCheckContainer = styled(Grid)<{ $variant: ToasterVariant }>(({ $variant: variant, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: theme.borderRadius.small,
  backgroundColor:
    variant === 'success'
      ? theme.tokens.background.semantic.success.main.hover
      : theme.tokens.background.semantic.error.main.default,
  color: theme.tokens.foreground.main.staticWhite
}))

export const StyledProgressLoader = styled(LinearProgress)<{ $isPaused: boolean }>(
  ({ $isPaused: isPaused, theme }) => ({
    height: '16px',
    borderRadius: '8px',
    backgroundColor: theme.tokens.background.tonal.soft.default,
    '.MuiLinearProgress-bar1Determinate': {
      borderRadius: '8px',
      backgroundColor: isPaused
        ? theme.tokens.foreground.main.disabled
        : theme.tokens.background.semantic.success.main.hover,
      transition: 'backgroundColor 0.1s linear, width 0.1s linear'
    }
  })
)
